import React, { FC, useCallback, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { BlueButton, NavButton } from 'components/Button'
import { MainHeadline } from 'components/Typography'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCampaigns } from 'reducks/campaign/operations'
import { State } from 'index'
import { getCampaigns } from 'reducks/campaign/selectors'
import { CampaignType } from 'types/campaign'
import { push } from 'connected-react-router'
import { CampaignCard } from 'components/Card'

const CampaignListTemplate: FC = () => {
  const dispatch = useDispatch()
  const campaigns: CampaignType[] = useSelector((state: State) => getCampaigns(state))
  const goToCampaignCreatePage = useCallback(() => dispatch(push('/admin/campaign_cms/create')), [dispatch])

  useEffect(() => {
    dispatch(fetchCampaigns())
  }, [])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'キャンペーン一覧'} />
      <Spacer size={20} />
      {campaigns.map((campaign) => {
        if (!campaign.campaign_id) return
        return (
          <React.Fragment key={campaign.campaign_id}>
            <CampaignCard
              campaignId={campaign.campaign_id}
              name={campaign.name}
              periodStart={campaign.period_start}
              periodEnd={campaign.period_end}
              status={campaign.status}
            />
            <Spacer size={20} />
          </React.Fragment>
        )
      })}
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'キャンペーンを作成する'}
        onClick={goToCampaignCreatePage}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={20} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/admin/shops'} />
      <Spacer size={72} />
    </div>
  )
}

export default CampaignListTemplate
